// ABOUTME: Notification component for the return_processed notification type.
// ABOUTME: Displays a return icon with body text and handles click-through to the return sidepanel.
import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../../theme";
import { AssignmentReturnOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import Text from "../../../theme/text/Text";

const ReturnProcessedNotificationsComp = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);

    return(
        <Box
            onClick={props.onClick ?? null}
            sx={{
                cursor:"pointer",
                px:1.5,
                display:"flex",
                gap:2,
                width:1,
                py:1.5,
                transition:"200ms",
                borderRadius:4,
                "&:hover" : {
                    background:colors.grey[100],
                    transition:"200ms",
                }
            }}
        >
            <Box
                sx={{
                    height:32,
                    width:32,
                    flexShrink:0,
                    display:'flex',
                    alignItems:"center",
                    justifyContent:'center',
                    background:theme.palette.mode === "dark" ? colors.green[100] : colors.green[100],
                    color:theme.palette.mode === "dark" ? colors.green[400] : colors.green[400],
                    borderRadius:3,
                }}
            >
                <AssignmentReturnOutlined fontSize="small"/>
            </Box>
            <Box flex={1}>
                <Box
                    sx={{
                        display:"flex",
                        alignItems:"center",
                        gap:1,
                        mb:0.5,
                    }}
                >
                    <Text semibold>{t(props.type)}</Text>
                </Box>
                <Box>
                    <Text>{props.body}</Text>
                </Box>
            </Box>
        </Box>
    )
}

export default ReturnProcessedNotificationsComp;
